// Centralized hash & in-page anchor navigation registry.
// Provides uniform behavior: activate registered handlers on initial load, hashchange, and anchor clicks.
// Usage: addAnchorHandlers([{ id: 'bakery', action: () => { /* ... */ } }])

const registry = new Map();
let initialized = false;

function handleHash(rawHash) {
    if (!rawHash || rawHash.length <= 1) return;
    const id = decodeURIComponent(rawHash.slice(1));
    const entry = registry.get(id);
    if (entry && typeof entry.action === 'function') {
        entry.action();
        if (entry.options?.scroll) {
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }
}

function onDocumentClick(e) {
    const anchor = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!anchor) return;
    const href = anchor.getAttribute('href');
    if (!href || href.indexOf('#') === -1) return;
    const id = decodeURIComponent(href.split('#').pop());
    if (!id) return;
    const entry = registry.get(id);
    if (!entry) return;
    e.preventDefault();
    // Update hash without adding history entries.
    if (entry.options?.updateHash !== false && history.replaceState) {
        const base = window.location.href.split('#')[0];
        history.replaceState(null, '', `${base}#${encodeURIComponent(id)}`);
    } else if (entry.options?.updateHash !== false) {
        window.location.hash = id;
    }
    entry.action();
    if (entry.options?.scroll) {
        const el = document.getElementById(id);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
}

function init() {
    if (initialized) return;
    initialized = true;
    window.addEventListener('hashchange', () => handleHash(window.location.hash));
    document.addEventListener('click', onDocumentClick, false);
    // Initial load
    handleHash(window.location.hash);
}

export function addAnchorHandlers(handlers, defaultOptions = {}) {
    if (!Array.isArray(handlers)) return () => {};
    handlers.forEach(h => {
        if (!h || !h.id || typeof h.action !== 'function') return;
        registry.set(h.id, { action: h.action, options: { scroll: true, updateHash: true, ...defaultOptions, ...h.options } });
    });
    init();
    // Return cleanup for these handlers
    return () => {
        handlers.forEach(h => registry.delete(h.id));
    };
}

export function clearAnchorHandlers() {
    registry.clear();
}
